import { useSearchParams } from '../../../hooks';

export const useIsAutomaticUpload = () => {
  const params = useSearchParams();
  const uploadType = params.get('upload_type');
  return uploadType !== 'manual';
};
